<ion-toolbar mode="md">
 <ion-item mode="ios">
  <app-shop-avatar 
  slot="start"
  [shop]="shopWithCoupons.shop"
  ></app-shop-avatar>
  <ion-label >
    <h2>{{shopWithCoupons.shop.name}}</h2>
    <p style="max-height: 2.5em;
    overflow: hidden;
    text-overflow: ellipsis;">{{shopWithCoupons.shop.address}}</p>
  </ion-label>
  <!-- TODO this should open a place preview with photos and such -->
  <!-- <ion-icon name="information-circle" color="light" slot="end"></ion-icon>  -->
  <!-- <ion-icon name="location" color="dark" slot="end"></ion-icon> -->
 </ion-item>
  <swiper 
  #swiper 
  [config]="swiperConfig"
  (swiper)="onSwiper($event)"
  (beforeTransitionStart)="onBeforeTransitionStart($event)">
    <ng-template swiperSlide *ngFor="let coupon of shopWithCoupons.coupons;" >
     <app-coupon-lane-card 
     [coupon]="coupon"
     [shop]="shopWithCoupons.shop"
     [cardHeight]="cardHeight"
     (onWantsToFlip)="slideNext()"
     (onCouponSelectEmit)="couponSelected($event)"
     >
     </app-coupon-lane-card>
    </ng-template>
</swiper>
</ion-toolbar>

